export enum DesktopProcessMessageType {
    cardioPerfectRestEcgCompleted = 'cardioPerfectRestEcgCompleted',
    cardioPerfectSpirometryCompleted = 'cardioPerfectSpirometryCompleted',
    careFusionSpirometryCompleted = 'careFusionSpirometryCompleted',
    completeMultipartUpload = 'completeMultipartUpload',
    createMultipartUpload = 'createMultipartUpload',
    error = 'error',
    generateHolterConfigurationData = 'generateHolterConfigurationData',
    holterCleared = 'holterCleared',
    holterConfigured = 'holterConfigured',
    holterDetectCompleted = 'holterDetectCompleted',
    holterDownloaded = 'holterDownloaded',
    holterDownloadProgress = 'holterDownloadProgress',
    holterUploaded = 'holterUploaded',
    holterUploadProgress = 'holterUploadProgress',
    info = 'info',
    signMultipartUploadUrl = 'signMultipartUploadUrl',
    signUploadUrl = 'signUploadUrl',
    start = 'start',
    update = 'update',
}
